import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
export const StyledGrid = styled(Grid)<{
  gridItemsNumber: number;
  offersBoutiquePickUp?: boolean;
}>`
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;
  row-gap: 16px;
  ${({ gridItemsNumber, theme }) => css`
    ${theme.media.sm.up} {
      grid-template-columns: ${gridItemsNumber >= 3
        ? 'repeat(3, 1fr)'
        : 'repeat(2, 1fr)'};
    }
    ${theme.media.md.up} {
      grid-template-columns: repeat(${gridItemsNumber}, 1fr);
    }
  `}
`;

export const StyledFlex = styled(Flex)`
  margin: 30px auto 0 auto;
  justify-content: center;
`;
export const Wrapper = styled(Box)`
  padding: 0 auto;
  margin-top: 0px;
  margin-bottom: 32px;
`;
export const ServicBox = styled(Box)`
  padding: 0 35px;
  width: 163px;
`;
export const PerkBox = styled(Box)``;
export const Text = styled(Box)`
  white-space: nowrap;
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.secondary};
  `};
`;
